<template>
	<div id="app">
        <TheNavigation :class="{'navbar-hidden': !showNavbar}"/>
		<transition name="fade" mode="out-in">
            <router-view :key="$route.path"/>
        </transition>
        <TheFooter/>
	</div>
</template>

<script>
import TheNavigation from "@/components/TheNavigation";
import TheFooter from "@/components/TheFooter";
export default {
    components: {
        TheNavigation,
        TheFooter
    },
    data() {
        return {
            showNavbar: true,
            lastScrollPosition: 0
        }
    },
    methods: {
        onScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollPosition < 0) {
                return;
            }

            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 110) {
                return;
            }

            this.showNavbar = currentScrollPosition < this.lastScrollPosition;
            this.lastScrollPosition = currentScrollPosition;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    }
}
</script>

<style scoped>
.navbar-hidden {
    transition: 0.3s all ease-in-out;
    transform: translate3d(0, -100%, 0);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
